import React, {useEffect, useRef, useState} from 'react';
import SectionTitle from '../../components/site/SectionTitle';
import SplitShowcase from '../../components/site/SplitShowcase';
import PocBotView from '../../components/site/PocBotView';
import {useWaitlist} from '../../components/site/WaitlistModal';
import {useSiteContent} from './siteContent';
import {useHeroCanvas} from '../../hooks/useHeroCanvas';
import DisabledPocNotice from '../../components/site/DisabledPocNotice';
import {systemConfigService} from '../../services/systemConfigService';
import styles from './SitePages.module.css';

const AutoTradingPocPage: React.FC = () => {
    const {autoPocPage: {hero, stories, sectionTitles}, waitlistCta} = useSiteContent();
    const {openWaitlist} = useWaitlist();
    const heroSectionRef = useRef<HTMLElement>(null);
    const heroCanvasRef = useRef<HTMLCanvasElement>(null);
    const [enabled, setEnabled] = useState<boolean | null>(null);

    useEffect(() => {
        loadConfig();
    }, []);

    useHeroCanvas(heroSectionRef, heroCanvasRef);

    const loadConfig = async () => {
        try {
            const response = await systemConfigService.getPocDisplayConfig();
            if ('0' === response.data.code) {
                setEnabled(response.data.data.autoTradingEnabled);
            } else {
                setEnabled(false);
            }
        } catch (error) {
            console.error('加载POC配置失败:', error);
            setEnabled(false);
        }
    };

    if (enabled === null) {
        return null;
    }

    if (!enabled) {
        return <DisabledPocNotice/>;
    }

    return (
        <div className={styles.page}>
            <section ref={heroSectionRef} className={`${styles.section} ${styles.heroSectionWrapper}`}>
                <canvas ref={heroCanvasRef} className={styles.heroSectionCanvas}/>
                <div style={{position: 'relative', zIndex: 1}}>
                    <SectionTitle
                        description={sectionTitles.demo.description}
                        eyebrow={sectionTitles.demo.eyebrow}
                        title={sectionTitles.demo.title}
                    />
                    <div className={`site-section ${styles.showcaseConstellation}`} data-hover-stop="constellation">
                        <PocBotView/>
                    </div>
                </div>
            </section>

            <section className={styles.section}>
                <SectionTitle
                    description={sectionTitles.stories.description}
                    eyebrow={sectionTitles.stories.eyebrow}
                    title={sectionTitles.stories.title}
                />
                <div className={`${styles.storyStack} site-section`}>
                    {stories.map((story, index) => (
                        <SplitShowcase block={story} key={story.title} reverse={index % 2 === 1}/>
                    ))}
                </div>
            </section>

            <section className={styles.section}>
                <article className={`site-card ${styles.ctaPanel}`}>
                    <div>
                        <span className="site-eyebrow">{hero.panelLabel}</span>
                        <h3>{hero.panelTitle}</h3>
                        <p>{hero.panelDescription}</p>
                    </div>
                    <div className={styles.ctaActions}>
                        <button className={styles.ctaButton} type="button" onClick={openWaitlist}>
                            {waitlistCta.label}
                        </button>
                    </div>
                </article>
            </section>
        </div>
    );
};

export default AutoTradingPocPage;
